const SystemSettings = window.SystemSettings;
import _ from "underscore"

//Functional-style methods to work with settings. Useful for reducers.

export function create(settings = {
    minimalLength: 0,
    ruleIds: []
}) {
    return {
        ruleIds: [],
        minimalLength: 0,
        ...settings
    }
}

export function hasRuleId(settings, rule) {
    return _.contains(settings.ruleIds, rule)
}

export function forOnlyId(settings, ruleId) {
    return {
        ...settings,
        ruleIds: [ruleId]
    }
}

export function addRuleId(settings, ruleId) {
    return {
        ...settings,
        ruleIds: _.union(settings.ruleIds, [ruleId])
    }
}

export function removeRuleId(settings, ruleId) {
    return {
        ...settings,
        ruleIds: _.without(settings.ruleIds, ruleId)
    }
}

export function change(settings, change) {
    return {
        ...settings,
        ...change
    }
}

export function toggleRuleId(settings, ruleId, value) {
    return value ? addRuleId(settings, ruleId) : removeRuleId(settings, ruleId);
}


let PasswordSettingsInstance = null;

export function getPasswordSettings()
{
    if (PasswordSettingsInstance === null) {
        PasswordSettingsInstance = create(SystemSettings.passwordSettings)
    }
    return PasswordSettingsInstance;
}

export function setPasswordSettings(newSettings)
{
    PasswordSettingsInstance = create(newSettings)
}

export const PasswordValidators = window.__GENERATED_CONSTANTS__.PasswordValidators;
export const PasswordValidatorId = window.__GENERATED_CONSTANTS__.PasswordValidatorId;


// WEBPACK FOOTER //
// ./web/js/util/passwords/PasswordSettings.js